<template>
  <layout-user-integration-settings
      active-navigation="inputFeed">
    <div class="">

      <div class="" v-if="isLoading">
        <div class="px-4 sm:px-6 lg:max-w-7xl lg:mx-auto lg:px-8">
          <div class="py-6 my-6 bg-white rounded" v-if="isLoading">
            <loader/>
          </div>
        </div>
      </div>

      <div class="" v-if="!isLoading">
        <div class="">
          <div class="">

            <!-- KPIs -->
            <div class="mt-8 px-4 sm:px-6 lg:max-w-7xl lg:mx-auto lg:px-8">
              <div class="pb-5 border-b border-gray-200">
                <div class="-ml-2  flex flex-wrap items-baseline">
                  <h3 class="ml-2 mt-2 text-xl leading-6 font-normal text-gray-900">
                    User Integration Record Input
                  </h3>
                  <p class="ml-2 mt-1 text-sm text-gray-500 truncate">
                    A Record from the Source Integration
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-8 px-4 sm:px-6 lg:max-w-7xl lg:mx-auto lg:px-8">
          <div
              class="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
            <div class="space-y-6 lg:col-start-1 lg:col-span-2">
              <!-- Description list-->
              <section aria-labelledby="applicant-information-title">
                <div class="bg-white shadow sm:rounded-lg">
                  <div class="px-4 py-5 sm:px-6">
                    <h2 id="applicant-information-title" class="text-lg leading-6 font-normal text-gray-900">
                      Transaction Information
                    </h2>
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">
                      Information about this record
                    </p>
                  </div>
                  <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
                    <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3">
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Integration Settings
                        </dt>
                        <dd class="mt-1 text-lg font-normal text-gray-900 truncate">
                          <a href="#" @click.prevent="onClickIntegrationSettings">
                            {{ getIntegrationSettingsTitle() }}
                          </a>
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Transaction Total
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          ${{ getTransactionTotal() }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Output Record
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate" v-if="shouldShowOutput()">
                            <a href="#" @click.prevent="onClickOutput" v-if="shouldShowOutput()">
                              {{ getIntegrationSettingsTitle() }}
                            </a>
                        </dd>
                        <dd class="text-sm font-normal text-gray-900 truncate" v-else>
                          Generating Output...
                        </dd>
                      </div>
                      <div class="sm:col-span-3">
                        <dt class="text-sm text-gray-500">
                          Transaction Description
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          {{getTransactionDescription()}}
                        </dd>
                      </div>
                      <div class="sm:col-span-3">
                        <dt class="text-sm text-gray-500">
                          Transaction Date
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          {{ getTransactionDate()}}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Source ID
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          {{ getSourceId() }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Transaction Type
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          {{ getTransactionType() }}
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Contact
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          <a href="#" @click.prevent="onClickContact" v-if="shouldShowContact()">
                            {{ getContactName() }}
                          </a>
                        </dd>
                      </div>
                      <div class="sm:col-span-1">
                        <dt class="text-sm text-gray-500">
                          Created At
                        </dt>
                        <dd class="text-lg font-normal text-gray-900 truncate">
                          {{ getCreatedDate() }}
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </section>
            </div>

            <section aria-labelledby="timeline-title" class="lg:col-start-3 lg:col-span-1">
              <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
                <h2 id="timeline-title" class="text-lg font-normal text-gray-900 truncate">

                </h2>

                <!-- Activity Feed -->
                <timeline :timeline="getTimeline()"></timeline>

                <div class="mt-6 flex flex-col justify-stretch">
                  <button type="button"
                          class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          @click.prevent="onClickOutput">
                    Go to Output Record
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </layout-user-integration-settings>
</template>

<script>
import {mapGetters} from "vuex";
import LayoutUserIntegrationSettings from "@/views/UserIntegrationSettings/Layout";
import Loader from "@/components/Loader";
import moment from 'moment';
import Timeline from "@/components/Timeline/Timeline";
import {formatMoney} from "accounting-js";

export default {
  name: "ViewAccountInput",

  components: {
    Timeline,
    Loader,
    LayoutUserIntegrationSettings
  },

  props: {

  },

  data: () => ({}),

  mounted() {
    this.loadRecord();
  },

  methods: {
    loadRecord() {
      this.$store.dispatch(
          "user_integration_record_inputs/readItem",
          this.$route.params.input_id
      ).then((item) => {

        // Get the contact
        this.$store.dispatch(
            "user_integration_settings_contacts/readItem",
            item.contact_id
        )

        // Get the output
        this.$store.dispatch(
            "user_integration_record_outputs/readItem",
            item.user_integration_record_output_id
        )
      })
    },

    getSourceURL() {
      return 'https://dashboard.stripe.com/search?query=' + this.inputRecord.source_id;
    },

    onClickIntegrationSettings() {
      return this.$router.push({
        name: 'user_integration_settings_view',
        params: {
          settings_id: this.inputRecord.user_integration_settings_id
        }
      });
    },

    onClickOutput() {
      return this.$router.push({
        name: 'user_integration_settings_view_output',
        params: {
          settings_id: this.inputRecord.user_integration_settings_id,
          output_id: this.inputRecord.user_integration_record_output_id
        }
      });
    },
    
    getTransactionTotal() {
      return formatMoney(this.inputRecord.transaction_total, {symbol: 'AUD', format: "%v"})
    },

    getIntegrationSettingsTitle() {
      return this.settingsRecord.title;
    },

    getOutputTitle() {
      return this.settingsRecord.transaction_description;
    },

    getCreatedDate() {
      return this.inputRecord.created_at
    },

    getTransactionDate() {
      return this.inputRecord.transaction_date
    },

    shouldShowOutput() {
      return this.inputRecord.user_integration_record_output_id
    },

    getTransactionDescription() {
      return this.inputRecord.transaction_description;
    },

    getSourceId() {
      return this.inputRecord.source_id
    },

    getTransactionType() {
      return this.inputRecord.transaction_type;
    },

    getContactName() {
      return this.contactRecord.email
    },

    onClickContact() {
      return this.$router.push({
        name: 'user_integration_settings_contacts',
        params: {
          settings_id: this.inputRecord.user_integration_settings_id,
          contact_id: this.inputRecord.contact_id
        }
      });
    },

    shouldShowContact() {
      return this.contactRecord
    },

    getTimeline() {
      return [
        {
          text: (item) => item.user_integration_record_output_id ? "Moved To Output" : "Moving to Output",
          status: this.inputRecord.user_integration_record_output_id ? 'Finished' : 'Pending',
          date: this.getCreatedDate(),
          link: {
            text: 'View Output',
            url: (item) => this.$router.push({
              name: 'user_integration_settings_view_output',
              params: {
                settings_id: item.user_integration_settings_id,
                output_id: item.user_integration_record_output_id
              }
            }),
            show: this.shouldShowOutput()
          }
        },
        {
          text: "Discovered Transaction",
          status: "Finished",
          date: this.getCreatedDate(),
          link: {
            text: 'View Source',
            url: this.getSourceURL(),
            show: this.inputRecord.source_id
          }
        }
      ]
    }
  },

  computed: {
    isLoading() {
      return this.isLoadingInput ||
          this.isLoadingOutput ||
          this.isLoadingContact
    },

    ...mapGetters({
      isLoadingSettings: 'user_integration_settings/getIsLoadingItem',
      isLoadingInput: 'user_integration_record_inputs/getIsLoadingItem',
      isLoadingOutput: 'user_integration_record_outputs/getIsLoadingItem',
      isLoadingContact: 'user_integration_settings_contacts/getIsLoadingItem',

      settingsRecord: 'user_integration_settings/getView',
      inputRecord: 'user_integration_record_inputs/getView',
      outputRecord: 'user_integration_record_outputs/getView',
      contactRecord: 'user_integration_settings_contacts/getView',
    })
  }
}
</script>

<style scoped>

</style>